module.exports = __webpack_public_path__ + "static/media/Open_Geospatial_Consortium_logo.4a857cef.png";